import React, { useState } from 'react';
import { Sidebar } from './components/layout/Sidebar';
import { Header } from './components/layout/Header';
import { Dashboard } from './pages/Dashboard';
import { Admissions } from './pages/Admissions';
import { FeeManagement } from './pages/FeeManagement';
import { HostelManagement } from './pages/HostelManagement';
import { Examinations } from './pages/Examinations';
import { Settings } from './pages/Settings';
import { CloudERPImplementation } from './pages/CloudERPImplementation';
export function App() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard data-id="element-0" />;
      case 'admissions':
        return <Admissions data-id="element-1" />;
      case 'fees':
        return <FeeManagement data-id="element-2" />;
      case 'hostel':
        return <HostelManagement data-id="element-3" />;
      case 'exams':
        return <Examinations data-id="element-4" />;
      case 'settings':
        return <Settings data-id="element-5" />;
      case 'cloud-erp':
        return <CloudERPImplementation data-id="element-6" />;
      default:
        return <Dashboard data-id="element-7" />;
    }
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-8">
      <Sidebar currentPage={currentPage} setCurrentPage={setCurrentPage} isOpen={sidebarOpen} toggleSidebar={() => setSidebarOpen(!sidebarOpen)} data-id="element-9" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-10">
        <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} sidebarOpen={sidebarOpen} data-id="element-11" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 bg-gray-50" data-id="element-12">
          {renderPage()}
        </main>
      </div>
    </div>;
}